import { Injectable } from '@angular/core';
import { ServicesData } from '../../providers/services-data';

@Injectable()
// Share methods between Mobile and Full Web view
export class ServicesCommon {
	constructor(
		private servicesData: ServicesData
	) {}

	public commonMethod(){
		console.log("Hello Services");
	}
	
}



// WEBPACK FOOTER //
// ./src/modules/services/pages/services/services.common.ts